module.exports = __webpack_public_path__ + "img/b886bfc.png";